<template>
  <el-row>
    <el-col :span="24" v-loading="loading">
      <el-tabs :value="active" type="border-card" @tab-click="tabClick">
        <el-tab-pane
          v-if="admin_role"
          name="collective_snapshot"
          label="Collective Reports"
        >
          <Collective />
        </el-tab-pane>
        <el-tab-pane name="channel_data" label="Channel Data">
          <Channels />
        </el-tab-pane>
        <el-tab-pane label="Video Data" name="video_data">
          <Videos />
        </el-tab-pane>
        <el-tab-pane label="Track Usage" name="track_data">
          <Tracks />
        </el-tab-pane>
        <!-- <el-tab-pane label="Weekly Reports" name="weekly_data">
          <Weekly />
        </el-tab-pane> -->
      </el-tabs>
    </el-col>
  </el-row>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import format from 'date-fns/format'
import subDays from 'date-fns/subDays'
import addDays from 'date-fns/addDays'
import Tracks from '../components/tracks/Table'
import Videos from '../components/videos/Table'
import Channels from '../components/channels/Table'
import Collective from '../components/Collective'
// import Weekly from '../components/Weekly'
// import TracksUserVue from '../../track-import/components/TracksUser.vue'

export default {
  components: {
    Tracks,
    Videos,
    Channels,
    Collective
  },

  data() {
    return {
      reports_date_range: [
        format(subDays(new Date(), 7), 'yyyy-MM-dd'),
        format(addDays(new Date(), 1), 'yyyy-MM-dd')
      ]
    }
  },

  computed: {
    ...mapState('reports', ['loading']),
    ...mapState('reportsChannels', ['channels']),
    ...mapState('reportsVideos', ['videos']),
    ...mapState('reportsTracks', ['tracks']),

    ...mapGetters('auth', ['admin_role']),

    active() {
      if (this.admin_role) return 'collective_snapshot'
      return 'video_data'
    }
  },

  methods: {
    ...mapActions('reports', ['readSnapshot']),
    ...mapActions('reportsChannels', ['readChannels', 'readChannelChart']),
    ...mapActions('reportsTracks', ['readTracks', 'readTrackChart']),
    ...mapActions('reportsVideos', ['readVideos', 'readVideoChart']),

    ...mapMutations('reports', ['setDateRange']),

    tabClick(tab) {
      if (tab.name === 'channel_data' && this.channels.length == 0) {
        let ls = JSON.parse(localStorage.getItem('channel_report_filter'))
        if (ls) this.readChannels(ls)
        else this.readChannels()
      }
      if (tab.name === 'track_data' && this.tracks.length == 0) {
        let ls = JSON.parse(localStorage.getItem('track_report_filter'))
        if (ls) this.readTracks(ls)
        else this.readTracks()
      }
      if (tab.name === 'video_data' && this.videos.length == 0) {
        let ls = JSON.parse(localStorage.getItem('video_report_filter'))
        if (ls) this.readVideos(ls)
        else this.readVideos()
      }
    },

    filter() {
      this.setDateRange({
        start: this.reports_date_range[0],
        end: this.reports_date_range[1]
      })
      if (this.admin_role) {
        this.readSnapshot()
      } else {
        this.readChannelData()
      }
    }
  },

  created() {
    // temporary fix
    setTimeout(() => {
      this.filter()
    }, 1000)
  }
}
</script>
